module.exports = __webpack_public_path__ + "img/banner3.89743157.png";